import React from 'react';
import { t } from '../../../../common/components/T';
import { svgSprite, Tooltip } from '../../../../hybrid/wrappers';
// import ExcelButton from '../../../../widgets/excelButton/ExcelButton';
import css from './structure-buttons.module.scss';
import classNames from 'classnames';

const StructureTableButtons = ({
    setTableVariant,
    variant,
    initData,
    setStructureViewData,
    setBreadCrumbsUsers,
    // exportData,
    showReloadBt,
    translation,
    loadData,
    setShowModal,
    showModal,
    fullScreen,
    setfullScreen,
    screenWidth,
    display_country
}) => {
    return (
        <div className={css.tableButtonsBlock}>
            <div className={classNames(css.flexRow, css.fullScreenButtonsWrap)}>
                <p className={css.tableTitle}>{t('structure-table-title', 'Список дистрибьюторов', '/structure', translation)}</p>
                <div className={css.lastButtonsWrap}>
                    <div className={css.flexRow}>
                        <div className={css.reloadBtnWrapper}>
                            {showReloadBt && (
                                <Tooltip
                                    text={t(
                                        'treegraph-buttonsBlock-reload',
                                        'Сбросить параметры поиска',
                                        '/structure',
                                        translation
                                    )}
                                >
                                    <div className={classNames('circleButton', css.tableSwitcher)} onClick={() => loadData()}>
                                        {svgSprite('reload', {
                                            width: '18px',
                                            height: '18px'
                                        })}
                                    </div>
                                </Tooltip>
                            )}
                        </div>
                        {screenWidth ? (
                            <div
                                onClick={() => {
                                    setTableVariant(variant === 1 ? 2 : 1);
                                    setStructureViewData(initData);
                                    setBreadCrumbsUsers(false);
                                }}
                                className={classNames(
                                    'circleButton',
                                    css.tableSwitcher,
                                    !!Number(display_country) && css.tableSwitcherDisabled
                                )}
                            >
                                {svgSprite(variant === 1 ? 'hierarchy' : 'list', {
                                    className: css.structureTableSwitcherSvg
                                })}
                            </div>
                        ) : (
                            <Tooltip
                                text={
                                    variant === 1
                                        ? t(
                                              'structure-change-view-button-hint-hierarchy',
                                              'Вид таблицы: структура',
                                              '/structure',
                                              translation
                                          )
                                        : t(
                                              'structure-change-view-button-hint-table',
                                              'Вид таблицы: список',
                                              '/structure',
                                              translation
                                          )
                                }
                            >
                                <div
                                    onClick={() => {
                                        setTableVariant(variant === 1 ? 2 : 1);
                                        setStructureViewData(initData);
                                        setBreadCrumbsUsers(false);
                                    }}
                                    className={classNames(
                                        'circleButton',
                                        css.tableSwitcher,
                                        !!Number(display_country) && css.tableSwitcherDisabled
                                    )}
                                >
                                    {svgSprite(variant === 1 ? 'hierarchy' : 'list', {
                                        className: css.structureTableSwitcherSvg
                                    })}
                                </div>
                            </Tooltip>
                        )}

                        <Tooltip text={t('structure-search-user', 'Поиск дистрибьютора', '/structure', translation)}>
                            <div
                                className={classNames('circleButton', css.tableSwitcher, css.searchButton)}
                                onClick={() => setShowModal(!showModal)}
                            >
                                {svgSprite('search-gt', {
                                    width: '20px',
                                    height: '21px',
                                    style: { stroke: 'none' }
                                })}
                            </div>
                        </Tooltip>
                        {/* <div
                            className={classNames(css.formCursorPointer, css.tableSwitcher)}
                            onClick={() => {
                                setTableVariant(variant === 1 ? 2 : 1);
                                setStructureViewData(initData);
                                setBreadCrumbsUsers(false);
                            }}
                        >
                            {svgSprite('graph-structure', {
                                className: classNames(css.structureTableSwitcherSvg, css.structureTableSwitcherSvgGraph, {
                                    [css.tableSwitcherSvgActive]: variant === 1
                                })
                            })}
                            <div className={css.switcherWrapper}>
                                <div
                                    className={classNames(
                                        css.switsherMark,
                                        css.switsherMarkWeb,
                                        variant !== 1 ? css.switsherMarkActive : ''
                                    )}
                                />
                            </div>
                            {svgSprite('table', {
                                className: classNames(css.structureTableSwitcherSvg, {
                                    [css.tableSwitcherSvgActive]: variant !== 1
                                })
                            })}
                        </div> */}
                        <Tooltip
                            text={
                                fullScreen
                                    ? t('structure-collapse', 'Свернуть', '/structure', translation)
                                    : t('structure-expand', 'Развернуть', '/structure', translation)
                            }
                        >
                            <div
                                className={classNames('circleButton', css.tableSwitcher, css.searchButton)}
                                onClick={() => setfullScreen(!fullScreen)}
                            >
                                {svgSprite(fullScreen ? 'expand-min' : 'expand-max', {
                                    width: '24px',
                                    height: '24px'
                                })}
                            </div>
                        </Tooltip>
                    </div>
                    {/* {exportData && <ExcelButton customStyles={{ customExportBtn: css.exportButton }} exportData={exportData} />} */}
                </div>
            </div>
        </div>
    );
};
export default StructureTableButtons;
